import { useEffect, useState } from 'react';

import { getAppContext } from '../../utils/environment';

import './DevBranchHeader.scss';

const DEV_BRANCH_ENDPOINT = '/__willow/dev-branch';
const REFRESH_INTERVAL_MS = 15_000;

interface DevBranchInfo {
  branch?: string;
  prUrl?: string;
}

const useDevBranchInfo = (): DevBranchInfo | undefined => {
  const [info, setInfo] = useState<DevBranchInfo>();

  useEffect(() => {
    let cancelled = false;

    const refresh = async () => {
      try {
        const response = await fetch(DEV_BRANCH_ENDPOINT);
        if (!response.ok) {
          return;
        }
        const next = (await response.json()) as DevBranchInfo;
        if (!cancelled) {
          setInfo(next);
        }
      } catch {
        // The endpoint only exists under `vite serve`; stay hidden otherwise.
      }
    };

    void refresh();
    const interval = window.setInterval(refresh, REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, []);

  return info;
};

export const DevBranchHeader = () => {
  if (getAppContext() !== 'development') {
    return null;
  }
  return <DevBranchHeaderContent />;
};

const DevBranchHeaderContent = () => {
  const info = useDevBranchInfo();

  if (!info?.branch) {
    return null;
  }

  const prNumber = info.prUrl?.split('/').pop();

  return (
    <div className="dev-branch-header">
      <span className="dev-branch-header__branch">{info.branch}</span>
      {info.prUrl && prNumber && (
        <a className="dev-branch-header__pr" href={info.prUrl} target="_blank" rel="noreferrer">
          PR #{prNumber}
        </a>
      )}
    </div>
  );
};
